export default [
    {
        path: "/voucher/fd/payment",
        component: () => import("../Components/List.vue"),
        name: "voucher.fd.payment",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/payment/create",
        component: () => import("../Components/Create.vue"),
        name: "voucher.fd.payment.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/payment/fund-pay",
        component: () => import("../Components/FundPay.vue"),
        name: "voucher.fd.payment.fund-pay",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/payment/bar-profit-pay",
        component: () => import("../Components/BarProfitPay.vue"),
        name: "voucher.fd.payment.bar-profit-pay",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/payment/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "voucher.fd.payment.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/fd/payment/:id/view",
        component: () => import("../Components/View.vue"),
        name: "voucher.fd.payment.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/fd/payment/pre-sanction-payment",
        component: () => import("../Components/PreSanctionPayment.vue"),
        name: "fd-voucher-pre-sanction-payment",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/fd/payment/pre-sanction-bank",
        component: () => import("../Components/PreSanctionBank.vue"),
        name: "fd-voucher-pre-sanction-bank",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/fd/payment/note-sheet-payment",
        component: () => import("../Components/NoteSheetPayment.vue"),
        name: "fd-voucher-note-sheet-payment",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/fd/payment/members-payment",
        component: () => import("../Components/MembersPayment.vue"),
        name: "fd-voucher-members-payment",
        meta: {
            requiresAuth: true,
        },
    },
];
